import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSosModel } from "../sosModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ISosDetail } from "../sosTypes";
import { formatNum } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useSosModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISosDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '业务员',
            width: 160,
            dataIndex: 'createUser',
            fixed: "left",
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '贸易国别 ',
            width: 100,
            dataIndex: 'countryName',
        }, {
            title: '报价次数',
            width: 160,
            dataIndex: 'inquiryNum',
        },
        // {
        //     title: '报价金额',
        //     width: 160,
        //     dataIndex: '',
        // }, {
        //     title: '合同金额',
        //     width: 160,
        //     dataIndex: '',
        // }, 
        {
            title: '合同数量',
            width: 160,
            dataIndex: 'saleNum',
        }, {
            title: '成交率',
            width: 80,
            dataIndex: "turnoverRate",
            render: t => t + "%"
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.code}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.code),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.code),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.code]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
